/* =============================================================================
   Guardián Urbano — JS del tema. Sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- utils */

  function formatMoney(cents, format) {
    var fmt = format || window.theme.moneyFormat || '${{amount}}';
    var value = Number(cents);
    if (isNaN(value)) return '';

    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return intPart + decPart;
    }

    var placeholder = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return fmt;

    var out;
    switch (placeholder[1]) {
      case 'amount': out = withDelimiters(value, 2, ',', '.'); break;
      case 'amount_no_decimals': out = withDelimiters(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = withDelimiters(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelimiters(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = withDelimiters(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = withDelimiters(value, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = withDelimiters(value, 2, ' ', '.'); break;
      default: out = withDelimiters(value, 2, ',', '.');
    }
    return fmt.replace(placeholder[0], out);
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* -------------------------------------------------------------- galería */

  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main) return;

    function show(thumb) {
      if (!thumb) return;
      var src = thumb.getAttribute('data-src');
      var srcset = thumb.getAttribute('data-srcset');
      var alt = thumb.getAttribute('data-alt') || '';
      if (src) main.src = src;
      main.srcset = srcset || '';
      main.alt = alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb); });
    });

    // El formulario avisa por evento en vez de tocar la galería directo: así
    // ninguno de los dos necesita saber cómo está construido el otro.
    document.addEventListener('theme:variant-media', function (event) {
      var id = event.detail && event.detail.id;
      if (!id) return;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('data-media-id') === String(id)) {
          show(thumbs[i]);
          return;
        }
      }
    });
  }

  /* --------------------------------------------------- barra fija (móvil) */

  function initStickyBar(bar) {
    var triggers = document.querySelectorAll('[data-sticky-trigger]');
    document.body.classList.add('has-stickybar');

    if (!triggers.length || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    // Se muestra cuando NINGÚN llamado a la acción está a la vista: hay dos
    // (el botón junto al precio y el formulario), y la barra encima de
    // cualquiera de ellos sería repetir el mismo botón dos veces.
    var visible = [];

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = visible.indexOf(entry.target);
        if (entry.isIntersecting && i === -1) visible.push(entry.target);
        if (!entry.isIntersecting && i !== -1) visible.splice(i, 1);
      });
      bar.classList.toggle('is-visible', visible.length === 0);
    }, { threshold: 0.15 });

    triggers.forEach(function (trigger) { observer.observe(trigger); });
  }

  /* -------------------------------------------------- formulario contraentrega */

  var COL_PHONE = /^3\d{9}$/;

  function setError(field, message) {
    if (!field) return;
    field.setAttribute('data-invalid', 'true');
    var slot = field.querySelector('.field__error');
    if (slot) slot.textContent = message;
  }

  function clearError(field) {
    if (field) field.removeAttribute('data-invalid');
  }

  function validate(form) {
    var ok = true;
    var firstInvalid = null;

    form.querySelectorAll('.field').forEach(clearError);

    form.querySelectorAll('[required]').forEach(function (input) {
      var field = input.closest('.field');
      var value = (input.value || '').trim();

      if (!value) {
        setError(field, window.theme.strings.required);
        ok = false;
        firstInvalid = firstInvalid || input;
        return;
      }

      if (input.name === 'phone') {
        var digits = value.replace(/\D/g, '').replace(/^57/, '');
        if (!COL_PHONE.test(digits)) {
          setError(field, window.theme.strings.phone);
          ok = false;
          firstInvalid = firstInvalid || input;
        }
      }
    });

    if (firstInvalid) firstInvalid.focus();
    return ok;
  }

  // Los radios de variante viven fuera del <form>, junto a la foto, asociados
  // con el atributo HTML form=". form.elements sí los incluye; querySelector no,
  // porque recorre el subárbol del DOM y no la lista de controles del formulario.
  function offerInputs(form) {
    var found = form.elements ? form.elements['offer'] : null;
    if (!found) return [];
    if (typeof found.length !== 'number') return [found];
    return Array.prototype.slice.call(found);
  }

  function selectedOffer(form) {
    var input = null;
    offerInputs(form).forEach(function (candidate) {
      if (candidate.checked) input = candidate;
    });
    if (!input) return null;
    return {
      variantId: input.value,
      quantity: parseInt(input.getAttribute('data-quantity'), 10) || 1,
      price: parseInt(input.getAttribute('data-price'), 10) || 0,
      title: input.getAttribute('data-title') || '',
      available: input.getAttribute('data-available') !== 'false',
      mediaId: input.getAttribute('data-media-id') || ''
    };
  }

  // Sin esto, el cliente llena ocho campos y recién ahí descubre que no hay
  // stock. Mejor decírselo con el formulario todavía vacío.
  function reflectAvailability(form) {
    var offer = selectedOffer(form);
    var button = form.querySelector('[data-order-submit]');
    var status = form.querySelector('[data-order-status]');
    if (!offer || !button) return;

    if (offer.available) {
      button.disabled = false;
      if (button.dataset.labelOriginal) button.textContent = button.dataset.labelOriginal;
      if (status && status.getAttribute('data-state') === 'soldout') {
        status.textContent = '';
        status.removeAttribute('data-state');
      }
    } else {
      if (!button.dataset.labelOriginal) button.dataset.labelOriginal = button.textContent.trim();
      button.disabled = true;
      button.textContent = window.theme.strings.soldOut;
      if (status) {
        status.textContent = window.theme.strings.soldOutNote;
        status.setAttribute('data-state', 'soldout');
      }
    }
  }

  function updateSummary(form) {
    var offer = selectedOffer(form);
    if (!offer) return;

    var total = offer.price * offer.quantity;
    var totalEl = form.querySelector('[data-order-total]');
    if (totalEl) totalEl.textContent = formatMoney(total);

    var pickEl = form.querySelector('[data-order-pick]');
    if (pickEl) pickEl.textContent = offer.title;

    document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
      el.textContent = formatMoney(total);
    });

    // Sólo si la variante tiene foto propia en Shopify. Mientras no la tengan,
    // el selector muestra swatches de color y la galería se queda quieta.
    if (offer.mediaId) {
      document.dispatchEvent(new CustomEvent('theme:variant-media', {
        detail: { id: offer.mediaId }
      }));
    }
  }

  function customerPayload(form) {
    var data = new FormData(form);
    var payload = {};
    ['name', 'phone', 'document', 'department', 'city', 'address', 'neighborhood', 'instagram', 'email', 'notes']
      .forEach(function (key) {
        var value = data.get(key);
        if (value) payload[key] = String(value).trim();
      });
    return payload;
  }

  function labelFor(key) {
    return {
      name: 'Nombre',
      phone: 'Celular',
      document: 'Cédula',
      department: 'Departamento',
      city: 'Ciudad',
      address: 'Dirección',
      neighborhood: 'Barrio',
      instagram: 'Instagram',
      email: 'Correo',
      notes: 'Notas'
    }[key] || key;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          // Shopify responde con un texto en español y entendible para el
          // cliente ("ya está agotado", "no queda suficiente stock"). Mostrarlo
          // es mucho más útil que un error genérico: sin esto, un problema de
          // inventario se ve igual que una caída de red.
          var err = new Error(data.description || data.message || 'HTTP ' + res.status);
          err.userMessage = data.description || data.message || null;
          throw err;
        }
        return data;
      });
    });
  }

  function submitToShopify(offer, customer) {
    var properties = {};
    Object.keys(customer).forEach(function (key) {
      properties[labelFor(key)] = customer[key];
    });
    properties['Forma de pago'] = 'Contraentrega';

    var attributes = {};
    Object.keys(customer).forEach(function (key) {
      attributes[labelFor(key)] = customer[key];
    });
    attributes['Forma de pago'] = 'Contraentrega';

    return postJSON(window.theme.routes.cartAdd, {
      items: [{ id: Number(offer.variantId), quantity: offer.quantity, properties: properties }]
    })
      .then(function () {
        return postJSON(window.theme.routes.cartUpdate, {
          attributes: attributes,
          note: 'Pedido contraentrega — ' + (customer.name || '') + ' — ' + (customer.phone || '')
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      });
  }

  function submitToEndpoint(form, offer, customer) {
    var endpoint = form.getAttribute('data-endpoint');
    var thankyou = form.getAttribute('data-thankyou') || '/';

    return postJSON(endpoint, {
      source: 'guardian-urbano',
      payment_method: 'contraentrega',
      product: form.getAttribute('data-product-title'),
      variant_id: offer.variantId,
      variant_title: offer.title,
      quantity: offer.quantity,
      unit_price: offer.price / 100,
      total: (offer.price * offer.quantity) / 100,
      currency: form.getAttribute('data-currency') || 'COP',
      customer: customer,
      page: window.location.href
    }).then(function () {
      window.location.href = thankyou;
    });
  }

  function initOrderForm(form) {
    offerInputs(form).forEach(function (input) {
      input.addEventListener('change', function () {
        updateSummary(form);
        reflectAvailability(form);
      });
    });
    updateSummary(form);
    reflectAvailability(form);

    // Limpia el error en cuanto el cliente corrige el campo.
    form.querySelectorAll('input, select, textarea').forEach(function (input) {
      input.addEventListener('input', function () { clearError(input.closest('.field')); });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!validate(form)) return;

      var offer = selectedOffer(form);
      if (!offer) return;

      var button = form.querySelector('[data-order-submit]');
      var status = form.querySelector('[data-order-status]');
      var mode = form.getAttribute('data-mode');
      var customer = customerPayload(form);

      button.disabled = true;
      button.classList.add('is-loading');
      if (status) { status.textContent = ''; status.removeAttribute('data-state'); }

      var request = mode === 'external' && form.getAttribute('data-endpoint')
        ? submitToEndpoint(form, offer, customer)
        : submitToShopify(offer, customer);

      request.catch(function (error) {
        console.error('[orden]', error);
        button.disabled = false;
        button.classList.remove('is-loading');
        if (status) {
          status.textContent = error.userMessage || window.theme.strings.generic;
          status.setAttribute('data-state', 'error');
        }
      });
    });
  }

  /* --------------------------------------------------- video con fachada */

  // El reproductor de YouTube/Vimeo solo se inserta cuando el visitante le da
  // play. Evita cargar cientos de KB de terceros en cada visita.
  function initVideoFacade(button) {
    button.addEventListener('click', function () {
      var type = button.getAttribute('data-video-type');
      var id = button.getAttribute('data-video-id');
      if (!id) return;

      var src = type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
        : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';

      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = button.getAttribute('aria-label') || 'Video';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder', '0');

      button.replaceWith(iframe);
    }, { once: true });
  }

  /* ------------------------------------------------ muro de videos */

  // Si el visitante abre un segundo video, el primero se pausa: cuatro audios
  // sonando a la vez es la forma más rápida de que cierre la pestaña.
  function initVideoWall(wall) {
    var videos = wall.querySelectorAll('video');
    videos.forEach(function (video) {
      video.addEventListener('play', function () {
        videos.forEach(function (other) {
          if (other !== video) other.pause();
        });
      });
    });
  }

  /* -------------------------------------------------- urgencia y entrega */

  /*
   * Corte de despacho y fecha estimada de entrega.
   *
   * Todo se calcula sobre la hora de la tienda, no la del navegador: se desplaza
   * el instante actual por el offset UTC configurado y luego se leen los campos
   * con getUTC*(). Así un visitante en Madrid ve el mismo contador que uno en
   * Bogotá, y la promesa de "sale hoy" nunca aparece cuando el corte ya pasó.
   */

  var DAY_SHORT = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var DAY_LONG = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MONTH_LONG = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  var urgencyTimer = null;

  function numberOr(value, fallback) {
    var n = Number(value);
    return isFinite(n) ? n : fallback;
  }

  function urgencyConfig() {
    var cfg = (window.theme && window.theme.urgency) || {};
    var min = Math.max(1, Math.round(numberOr(cfg.deliveryMin, 2)));
    var max = Math.max(1, Math.round(numberOr(cfg.deliveryMax, 4)));

    return {
      utcOffset: numberOr(cfg.utcOffset, -5),
      cutoffHour: Math.min(23, Math.max(0, Math.round(numberOr(cfg.cutoffHour, 17)))),
      shipSaturday: cfg.shipSaturday === true,
      minDays: Math.min(min, max),
      maxDays: Math.max(min, max),
      textToday: cfg.textToday || 'Pídelo antes de las [hora] y sale hoy mismo · quedan [tiempo]',
      textNext: cfg.textNext || 'Pídelo ahora y sale [dia]',
      deliveryLabel: cfg.deliveryLabel || 'Recibe entre el',
      deliveryLabelSingle: cfg.deliveryLabelSingle || 'Recibe el'
    };
  }

  // Instante actual expresado como reloj de pared de la tienda.
  function shopNow(utcOffset) {
    return new Date(Date.now() + utcOffset * 3600000);
  }

  function isBusinessDay(date, shipSaturday) {
    var day = date.getUTCDay();
    if (day === 0) return false;
    if (day === 6) return shipSaturday;
    return true;
  }

  function addBusinessDays(date, count, shipSaturday) {
    var d = new Date(date.getTime());
    var added = 0;
    var guard = 0;
    while (added < count && guard < 400) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDay(d, shipSaturday)) added++;
      guard++;
    }
    return d;
  }

  // Día en que sale el pedido: hoy si es hábil y aún no pasó el corte.
  function dispatchDay(now, cfg) {
    if (isBusinessDay(now, cfg.shipSaturday) && now.getUTCHours() < cfg.cutoffHour) {
      return { date: new Date(now.getTime()), sameDay: true };
    }
    return { date: addBusinessDays(now, 1, cfg.shipSaturday), sameDay: false };
  }

  function formatHour(hour) {
    var suffix = hour < 12 ? 'a.m.' : 'p.m.';
    var h12 = hour % 12;
    if (h12 === 0) h12 = 12;
    return h12 + ':00 ' + suffix;
  }

  function formatCountdown(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var hours = Math.floor(total / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    if (hours > 0) return hours + ' h ' + minutes + ' min';
    if (minutes > 0) return minutes + ' min ' + seconds + ' s';
    return seconds + ' s';
  }

  function formatDayMonth(date, withMonth) {
    var out = DAY_SHORT[date.getUTCDay()] + ' ' + date.getUTCDate();
    return withMonth ? out + ' de ' + MONTH_LONG[date.getUTCMonth()] : out;
  }

  function formatRange(from, to) {
    var sameDate = from.getUTCFullYear() === to.getUTCFullYear()
      && from.getUTCMonth() === to.getUTCMonth()
      && from.getUTCDate() === to.getUTCDate();

    if (sameDate) return { single: true, text: formatDayMonth(from, true) };

    var sameMonth = from.getUTCFullYear() === to.getUTCFullYear()
      && from.getUTCMonth() === to.getUTCMonth();

    return {
      single: false,
      text: formatDayMonth(from, !sameMonth) + ' y el ' + formatDayMonth(to, true)
    };
  }

  function dispatchLabel(now, target) {
    var a = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    var b = Date.UTC(target.getUTCFullYear(), target.getUTCMonth(), target.getUTCDate());
    var days = Math.round((b - a) / 86400000);
    if (days <= 1) return 'mañana';
    return 'el ' + DAY_LONG[target.getUTCDay()];
  }

  function msUntilCutoff(now, cutoffHour) {
    var target = new Date(now.getTime());
    target.setUTCHours(cutoffHour, 0, 0, 0);
    return target.getTime() - now.getTime();
  }

  function renderUrgency() {
    var cutoffNodes = document.querySelectorAll('[data-cutoff]');
    var deliveryNodes = document.querySelectorAll('[data-delivery]');
    if (!cutoffNodes.length && !deliveryNodes.length) return false;

    var cfg = urgencyConfig();
    var now = shopNow(cfg.utcOffset);
    var dispatch = dispatchDay(now, cfg);

    var cutoffText = dispatch.sameDay
      ? cfg.textToday
          .replace('[hora]', formatHour(cfg.cutoffHour))
          .replace('[tiempo]', formatCountdown(msUntilCutoff(now, cfg.cutoffHour)))
      : cfg.textNext.replace('[dia]', dispatchLabel(now, dispatch.date));

    cutoffNodes.forEach(function (node) {
      var out = node.querySelector('[data-cutoff-text]');
      if (!out) return;
      out.textContent = cutoffText;
      node.hidden = false;
    });

    var range = formatRange(
      addBusinessDays(dispatch.date, cfg.minDays, cfg.shipSaturday),
      addBusinessDays(dispatch.date, cfg.maxDays, cfg.shipSaturday)
    );

    deliveryNodes.forEach(function (node) {
      var label = node.querySelector('[data-delivery-label]');
      var value = node.querySelector('[data-delivery-range]');
      if (!value) return;
      if (label) label.textContent = range.single ? cfg.deliveryLabelSingle : cfg.deliveryLabel;
      value.textContent = range.text;
      node.hidden = false;
    });

    return true;
  }

  // Un solo intervalo para todo lo que cuenta segundos: dos timers a 1 s
  // acaban desfasados entre sí y muestran horas distintas en la misma pantalla.
  function tickUrgency() {
    var a = renderUrgency();
    var b = renderCountbars();
    return a || b;
  }

  function initUrgency() {
    if (urgencyTimer) clearInterval(urgencyTimer);
    if (!tickUrgency()) return;
    syncCountbarOffset();
    urgencyTimer = setInterval(tickUrgency, 1000);
  }

  /* -------------------------------------------- contador del tope (countbar) */

  /*
   * Barra de cuenta regresiva del tope de la página. Se apoya en el mismo reloj
   * de tienda que el bloque de urgencia, así que el contador de arriba y el del
   * formulario nunca se contradicen.
   *
   * Modo "cutoff": cuenta hasta el corte de despacho de hoy y, pasado el corte,
   * muestra el texto de cierre en vez de arrancar otro contador inventado.
   * Modo "date": cuenta hasta una fecha fija de la tienda.
   */

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // La fecha del ajuste es hora de pared de la tienda, no UTC ni la del visitante:
  // se arma con Date.UTC para poder compararla contra shopNow(), que usa la misma
  // convención (getUTC* devuelve la hora de la tienda).
  function parseShopDate(value) {
    var match = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T ](\d{1,2}):(\d{2}))?$/.exec((value || '').trim());
    if (!match) return null;
    var hours = match[4] === undefined ? 23 : Number(match[4]);
    var minutes = match[5] === undefined ? 59 : Number(match[5]);
    if (hours > 23 || minutes > 59) return null;
    return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), hours, minutes, 0, 0);
  }

  function spellRemaining(days, hours, minutes) {
    var parts = [];
    if (days > 0) parts.push(days + (days === 1 ? ' día' : ' días'));
    if (hours > 0) parts.push(hours + (hours === 1 ? ' hora' : ' horas'));
    parts.push(minutes + (minutes === 1 ? ' minuto' : ' minutos'));
    if (parts.length === 1) return parts[0];
    return parts.slice(0, -1).join(', ') + ' y ' + parts[parts.length - 1];
  }

  /*
   * Oferta recurrente: el ciclo se ancla a la medianoche de la tienda, así el
   * contador cae siempre a la misma hora del día en vez de derivar. Todos los
   * visitantes ven el mismo número, sobrevive recargas y cambios de dispositivo.
   */
  function msLeftInCycle(now, cycleHours) {
    var cycle = Math.max(1, cycleHours) * 3600000;
    var midnight = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0, 0);
    var into = (now.getTime() - midnight) % cycle;
    if (into < 0) into += cycle;
    return cycle - into;
  }

  // localStorage tira excepción en modo privado y con cookies bloqueadas, así que
  // nunca se lo llama sin red: si falla, el contador vive en memoria y dura lo
  // que dure la pestaña.
  var memoryStore = {};

  function readStore(key) {
    try {
      var raw = window.localStorage.getItem(key);
      if (raw !== null) return Number(raw) || null;
    } catch (e) { /* sin almacenamiento disponible */ }
    return Object.prototype.hasOwnProperty.call(memoryStore, key) ? memoryStore[key] : null;
  }

  function writeStore(key, value) {
    memoryStore[key] = value;
    try { window.localStorage.setItem(key, String(value)); } catch (e) { /* idem */ }
  }

  /*
   * Oferta por visitante: cada uno arranca su propia cuenta en la primera visita
   * y se guarda el instante de fin, no lo que falta. Guardar lo que falta haría
   * que el reloj se congelara entre visitas y volviera a empezar en cada carga,
   * que es lo que delata el truco a la primera recarga.
   */
  function evergreenRemaining(bar) {
    var minutes = Number(bar.getAttribute('data-minutes')) || 120;
    var span = minutes * 60000;
    var key = 'gu:countbar:' + (bar.getAttribute('data-key') || 'default') + ':' + minutes;
    var now = Date.now();
    var endsAt = readStore(key);

    // Un valor ausente, corrupto o más lejano que la duración (pasa si el
    // visitante movió el reloj del sistema) se descarta y se arranca de nuevo.
    if (endsAt === null || endsAt - now > span) {
      endsAt = now + span;
      writeStore(key, endsAt);
    }

    var left = endsAt - now;
    if (left <= 0 && bar.getAttribute('data-restart') === 'true') {
      endsAt = now + span;
      writeStore(key, endsAt);
      left = span;
    }
    return left;
  }

  function countbarDone(bar, text) {
    if (!text) {
      bar.hidden = true;
      return;
    }
    var label = bar.querySelector('[data-countbar-text]');
    var clock = bar.querySelector('[data-countbar-clock]');
    var sr = bar.querySelector('[data-countbar-sr]');
    if (label) label.textContent = text;
    if (clock) clock.hidden = true;
    if (sr) sr.textContent = '';
    bar.setAttribute('data-state', 'done');
    bar.hidden = false;
  }

  function renderCountbar(bar, cfg, now) {
    var mode = bar.getAttribute('data-mode');
    var isDate = mode === 'date';
    var remaining;
    var text = bar.getAttribute('data-text') || '';
    var after = bar.getAttribute('data-text-after') || '';

    if (isDate) {
      var end = parseShopDate(bar.getAttribute('data-end'));
      if (end === null) {
        bar.hidden = true;
        return;
      }
      remaining = end - now.getTime();
      if (remaining <= 0) {
        countbarDone(bar, bar.getAttribute('data-hide-done') === 'true' ? '' : after);
        return;
      }
    } else if (mode === 'recurring') {
      remaining = msLeftInCycle(now, Number(bar.getAttribute('data-cycle-hours')) || 24);
    } else if (mode === 'evergreen') {
      remaining = evergreenRemaining(bar);
      if (remaining <= 0) {
        countbarDone(bar, bar.getAttribute('data-hide-done') === 'true' ? '' : after);
        return;
      }
    } else {
      var dispatch = dispatchDay(now, cfg);
      if (!dispatch.sameDay) {
        countbarDone(bar, after.replace('[dia]', dispatchLabel(now, dispatch.date)));
        return;
      }
      remaining = msUntilCutoff(now, cfg.cutoffHour);
      text = text.replace('[hora]', formatHour(cfg.cutoffHour));
    }

    // Un [hora] o [dia] sin reemplazar aparecería tal cual en la barra: pasa al
    // cambiar de modo sin actualizar el texto. Mejor borrarlo que publicarlo.
    text = text.replace(/\[(hora|dia|tiempo)\]/g, '').replace(/\s{2,}/g, ' ').trim();

    var total = Math.max(0, Math.floor(remaining / 1000));
    var days = Math.floor(total / 86400);
    var hours = days > 0 ? Math.floor((total % 86400) / 3600) : Math.floor(total / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;

    var label = bar.querySelector('[data-countbar-text]');
    var clock = bar.querySelector('[data-countbar-clock]');
    var unitDays = bar.querySelector('[data-countbar-unit="days"]');
    var out = {
      days: bar.querySelector('[data-countbar-days]'),
      hours: bar.querySelector('[data-countbar-hours]'),
      minutes: bar.querySelector('[data-countbar-minutes]'),
      seconds: bar.querySelector('[data-countbar-seconds]')
    };

    if (label) label.textContent = text;
    if (clock) clock.hidden = false;
    if (unitDays) unitDays.hidden = days === 0;
    if (out.days) out.days.textContent = pad2(days);
    if (out.hours) out.hours.textContent = pad2(hours);
    if (out.minutes) out.minutes.textContent = pad2(minutes);
    if (out.seconds) out.seconds.textContent = pad2(seconds);

    // El texto para lectores de pantalla solo se reescribe al cambiar el minuto:
    // regenerarlo cada segundo obligaría al lector a repetirlo sin parar.
    var stamp = days + ':' + hours + ':' + minutes;
    if (bar.dataset.srStamp !== stamp) {
      bar.dataset.srStamp = stamp;
      var sr = bar.querySelector('[data-countbar-sr]');
      if (sr) sr.textContent = text + ' ' + spellRemaining(days, hours, minutes) + '.';
    }

    bar.removeAttribute('data-state');
    bar.hidden = false;
  }

  function renderCountbars() {
    var bars = document.querySelectorAll('[data-countbar]');
    if (!bars.length) return false;

    var cfg = urgencyConfig();
    var now = shopNow(cfg.utcOffset);
    var resync = false;

    bars.forEach(function (bar) {
      var wasHidden = bar.hidden;
      renderCountbar(bar, cfg, now);
      // Medir el alto cada segundo forzaría un reflow por tick. Solo hace falta
      // cuando una barra fija aparece o desaparece (fecha que vence con la
      // página abierta): ahí cambia el espacio que debe dejar el encabezado.
      if (bar.hidden !== wasHidden && bar.classList.contains('countbar--sticky')) resync = true;
    });

    if (resync) syncCountbarOffset();
    return true;
  }

  // Con la barra fija hay dos elementos peleando por el borde superior: el
  // encabezado también es sticky. Medimos el alto real y el CSS baja el header
  // esa cantidad, en vez de dejar un valor fijo que se rompe cuando el texto
  // pasa a dos líneas en un celular angosto.
  function syncCountbarOffset() {
    var sticky = document.querySelector('.countbar--sticky:not([hidden])');
    var height = sticky ? sticky.offsetHeight : 0;
    document.documentElement.style.setProperty('--countbar-h', height + 'px');
    document.body.classList.toggle('has-countbar-sticky', height > 0);
  }

  /* ------------------------------------------------------------ scroll a */

  function initScrollLinks() {
    document.querySelectorAll('[data-scroll-to]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('data-scroll-to'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var firstInput = target.querySelector('input:not([type="radio"]), select');
        if (firstInput) setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 500);
      });
    });
  }

  /* ------------------------------------------------------------- arranque */

  function boot() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-order-form]').forEach(initOrderForm);
    document.querySelectorAll('[data-video-facade]').forEach(initVideoFacade);
    document.querySelectorAll('[data-video-wall]').forEach(initVideoWall);
    var bar = document.querySelector('[data-sticky-bar]');
    if (bar) initStickyBar(bar);
    initUrgency();
    initScrollLinks();
  }

  window.addEventListener('resize', syncCountbarOffset);

  onReady(boot);

  // Reinicializa al editar secciones en el personalizador de Shopify.
  document.addEventListener('shopify:section:load', boot);
})();
